import React, { useState, useEffect, useCallback } from 'react';
import { Card } from 'components/ui';
import { toast } from 'sonner';
import {
  DocumentTextIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';
import { getApplicationById } from 'services/applicantService';
import ApplicationFormStage from 'components/leadUser/stages/ApplicationFormStage';

const ApplicationFormViewTab = ({ applicationId,leadUserId,leadData,progressData, isMobile = false,refreshProgressJourney, onLeadDataRefresh }) => {
  const [applicationForm, setApplicationForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const handleFieldSaved = useCallback((fieldId, value) => {
    setApplicationForm((prev) => {
      if (!prev || !prev.Steps) {
        return prev;
      }

      const updatedSteps = prev.Steps.map((step) => {
        if (!step.Fields) {
          return step;
        }

        const updatedFields = step.Fields.map((field) =>
          field.FieldId === fieldId ? { ...field, Value: value } : field
        );

        return { ...step, Fields: updatedFields };
      });

      return { ...prev, Steps: updatedSteps };
    });
  }, []);
  useEffect(() => {
    if (!applicationId) {
      setLoading(false);
      setError('Application is not started.');
      return;
    }

    const fetchApplicationData = async () => {
      setLoading(true);
      try {
        const response = await getApplicationById(applicationId);
        if (response.success && response.data) {
          setApplicationForm(response.data);
          setError(null);
        } else {
          setError(response.message || 'Failed to fetch application data');
          setApplicationForm(null);
        }
      } catch (err) {
        console.error('Error fetching application:', err);
        setError('Failed to fetch application data');
        setApplicationForm(null);
      } finally {
        setLoading(false);
      }
    };

    fetchApplicationData();
  }, [applicationId]);

  if (loading) {
    return (
      <Card className={`${isMobile ? 'p-4' : 'p-8'}`}>
        <div className="flex items-center justify-center py-12">
          <div className="text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto mb-4"></div>
            <p className="text-sm text-gray-500 dark:text-gray-400">Loading application form...</p>
          </div>
        </div>
      </Card>
    );
  }

  if (error) {
    return (
      <Card className={`${isMobile ? 'p-4' : 'p-8'}`}>
        <div className="text-center py-8">
          <ExclamationTriangleIcon className="h-12 w-12 text-red-500 mx-auto mb-4" />
          <p className="text-gray-600 dark:text-gray-400">{error}</p>
        </div>
      </Card>
    );
  }

  if (!applicationForm) {
    return (
      <Card className={`${isMobile ? 'p-4' : 'p-8'}`}>
        <div className="text-center py-8">
          <DocumentTextIcon className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-600 dark:text-gray-400">No application form available</p>
        </div>
      </Card>
    );
  }

  const { Title, Description, Steps = [] } = applicationForm;

  return (
    <ApplicationFormStage 
      companyName={leadData?.companyName} 
      useCase={"counsellor"} 
      leadUserId={leadUserId}  
      isFormSubmitted={progressData?.IsApplicationSubmitted} 
      applicationForm={applicationForm} 
      applicationId={applicationId} 
      loading={loading} 
      onProgressUpdate={refreshProgressJourney} 
      onLeadDataRefresh={onLeadDataRefresh}
      onFieldSaved={handleFieldSaved} 
      progressData={progressData} 
      leadDetails={leadData} 
      leadData={leadData}
    />
  );
};

export default ApplicationFormViewTab;
